var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTWin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-374.2 263 65.6 72",
    style: {
      enableBackground: "new -374.2 263 65.6 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFB41D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-341.6,263c-18.3,0-32.6,14.7-32.6,32.6c0,20.6,5.8,22.8,14.3,21.9c0,0,3.1,17.4,8.5,17.4c5.4,0,10.3,0,10.3,0 s4.9,0,9.8,0c4.9,0,8.5-17.4,8.5-17.4c8.5,0.9,14.3-1.3,14.3-21.9C-308.5,277.7-323.2,263-341.6,263z M-359.7,306.8 c-4.5-1.4-6.7-7.1-4.9-12.8c1.8-5.7,6.8-9.1,11.3-7.7c4.5,1.4,6.7,7.1,4.9,12.8C-350.1,304.7-355.2,308.2-359.7,306.8z  M-341.1,315.2c-3.6,0-6.7,7.6-6.7-0.4c0-0.4,0-0.9,0-1.3c0.9-3.6,4-9.4,6.3-9.4c2.7,0,6.7,6.7,6.7,9.8c0,0,0,0.4,0.4,0.9 C-334.4,322.4-338,315.2-341.1,315.2z M-322.8,306.7c-4.5,1.4-9.5-2.1-11.3-7.7c-1.8-5.7,0.5-11.4,4.9-12.8 c4.5-1.4,9.5,2.1,11.3,7.7C-316.1,299.6-318.3,305.3-322.8,306.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTWin);
export default __webpack_public_path__ + "static/media/t_win.0b2224135d897a26de50f8468743f527.svg";
export { ForwardRef as ReactComponent };